<template>
    <div class="StepHead">
        <div class="Steps">
            <div class="StepsItem">4. 案例报告</div>
        </div>
        <div class="ZhuanYe" v-if="TypeId == 1">
            <!-- <div class="StepHeadTit">* 符合下列条件之一，可直接申请注册</div> -->
            <div style="margin-top: 20px;" class="ZhuanYeItem" v-if="user_group_id != 4 && user_group_id != '4'">
                <!-- <div class="ZhuanYeItemTit">所在心理服务专业机构<div class="MarTop">或</div>
                </div> -->
                <div class="ZhuanYeItemRadio">
                    <input class="radio" type="radio" :id="'option1'" :value="1" v-model="selected" />
                    <label class="radio-label" :for="'option1'">所在心理服务专业机构</label>
                </div>
                <div class="ZhuanYeItemCont" v-if="selected === 1">
                    <div class="ZhuanYeItemDis">
                        <div class="ZhuanYeItemFuTit">机构名称</div>
                        <div class="ZhuanYeItemVal"><el-input size="small" placeholder="请输入" v-model="mechanism.name"
                                @input="onInputName(mechanism.name, selected, 'mechanism')"></el-input></div>
                    </div>
                    <div class="ZhuanYeItemDis">
                        <div class="ZhuanYeItemFuTit">注册号</div>
                        <div class="ZhuanYeItemVal"><el-input size="small" placeholder="请输入"
                                v-model="mechanism.code"></el-input></div>
                    </div>
                    <div class="ZhuanYeItemDis">
                        <div class="ZhuanYeItemFuTit"></div>
                        <div class="ZhuanYeItemVal button-group">
                            <el-button type="primary" size="small" @click="downloadTemplate">下载模板</el-button>
                            <el-upload action="none" size="small" :show-file-list="false" :http-request="(file) => UpFile(file, 'mechanism')">
                                <el-button type="primary" size="small">上传</el-button>
                            </el-upload>
                            <div class="StepCommFileImg" v-if="mechanism.file">
                                <img :src="$Global._isFileName(mechanism.file)" alt="" @click="OpenLock(mechanism.file)">
                                <i class="iconfont icon-guanbi2fill" @click="CloseImg(mechanism)"></i>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="ZhuanYeItem">
                <!-- <div class="ZhuanYeItemTit">注册督导师<div class="MarTop40">或</div></div> -->
                <div class="ZhuanYeItemRadio">
                    <input class="radio" type="radio" :id="'option2'" :value="2" v-model="selected" />
                    <label class="radio-label" :for="'option2'">注册督导师</label>
                    <span class="note-text">（注：中国心理卫生协会、中国心理学会、中国社会心理学会的均认可）</span>
                </div>
                <div class="ZhuanYeItemCont" v-if="selected === 2">
                    <div class="ZhuanYeItemTit">注册督导师1</div>
                    <div>
                        <div class="ZhuanYeItemDis">
                            <div class="ZhuanYeItemFuTit">姓名</div>
                            <div class="ZhuanYeItemVal"><el-input size="small" placeholder="请输入" v-model="tutor.name"
                                    @input="onInputName(tutor.name, selected, 'tutor')"></el-input></div>
                        </div>
                        <div class="ZhuanYeItemDis">
                            <div class="ZhuanYeItemFuTit">注册号</div>
                            <div class="ZhuanYeItemVal"><el-input size="small" placeholder="请输入"
                                    v-model="tutor.code"></el-input></div>
                        </div>
                        <div class="ZhuanYeItemDis">
                            <div class="ZhuanYeItemFuTit">电话</div>
                            <div class="ZhuanYeItemVal"><el-input size="small" placeholder="请输入" v-model="tutor.mobile"></el-input></div>
                        </div>
                        <div class="ZhuanYeItemDis">
                            <div class="ZhuanYeItemFuTit"></div>
                            <div class="ZhuanYeItemVal button-group">
                                <el-button type="primary" size="small" @click="downloadTemplate">下载模板</el-button>
                                <el-upload action="none" size="small" :show-file-list="false" :http-request="(file) => UpFile(file, 'tutor')">
                                    <el-button type="primary" size="small">上传</el-button>
                                </el-upload>
                                <div class="StepCommFileImg" v-if="tutor.file">
                                    <img :src="$Global._isFileName(tutor.file)" alt="" @click="OpenLock(tutor.file)">
                                    <i class="iconfont icon-guanbi2fill" @click="CloseImg(tutor)"></i>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="ZhuanYeItem" v-if="selected === 2 && (user_group_id == 3 || user_group_id == 4)">
                <div class="ZhuanYeItemCont">
                    <div class="ZhuanYeItemTit">注册督导师2</div>
                    <div>
                        <div class="ZhuanYeItemDis">
                            <div class="ZhuanYeItemFuTit">姓名</div>
                            <div class="ZhuanYeItemVal"><el-input size="small" placeholder="请输入" v-model="tutor2.name"
                                    @input="onInputName(tutor2.name, selected, 'tutor2')"></el-input></div>
                        </div>
                        <div class="ZhuanYeItemDis">
                            <div class="ZhuanYeItemFuTit">注册号</div>
                            <div class="ZhuanYeItemVal"><el-input size="small" placeholder="请输入"
                                    v-model="tutor2.code"></el-input></div>
                        </div>
                        <div class="ZhuanYeItemDis">
                            <div class="ZhuanYeItemFuTit">电话</div>
                            <div class="ZhuanYeItemVal"><el-input size="small" placeholder="请输入" v-model="tutor2.mobile"></el-input></div>
                        </div>
                        <div class="ZhuanYeItemDis">
                            <div class="ZhuanYeItemFuTit"></div>
                            <div class="ZhuanYeItemVal button-group">
                                <el-button type="primary" size="small" @click="downloadTemplate">下载模板</el-button>
                                <el-upload action="none" size="small" :show-file-list="false" :http-request="(file) => UpFile(file, 'tutor2')">
                                    <el-button type="primary" size="small">上传</el-button>
                                </el-upload>
                                <div class="StepCommFileImg" v-if="tutor2.file">
                                    <img :src="$Global._isFileName(tutor2.file)" alt="" @click="OpenLock(tutor2.file)">
                                    <i class="iconfont icon-guanbi2fill" @click="CloseImg(tutor2)"></i>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="ZhuanYeItem" v-if="user_group_id != 3 && user_group_id != '3' && user_group_id != 4 && user_group_id != '4'">
                <div class="ZhuanYeItemRadio">
                    <input class="radio" type="radio" :id="'option3'" :value="3" v-model="selected" />
                    <label class="radio-label" :for="'option3'">注册心理咨询师</label>
                    <span class="note-text">（注：中国心理卫生协会、中国心理学会、中国社会心理学会的均认可）</span>
                </div>
                <div class="ZhuanYeItemCont" v-if="selected === 3">
                    <div class="ZhuanYeItemTit">注册心理咨询师1</div>
                    <div>
                        <div class="ZhuanYeItemDis">
                            <div class="ZhuanYeItemFuTit">姓名</div>
                            <div class="ZhuanYeItemVal"><el-input size="small" placeholder="请输入"
                                    v-model="consultant1.name"
                                    @input="onInputName(consultant1.name, selected, 'consultant1')"></el-input></div>
                        </div>
                        <div class="ZhuanYeItemDis">
                            <div class="ZhuanYeItemFuTit">注册号</div>
                            <div class="ZhuanYeItemVal"><el-input size="small" placeholder="请输入"
                                    v-model="consultant1.code"></el-input></div>
                        </div>
                        <div class="ZhuanYeItemDis">
                            <div class="ZhuanYeItemFuTit">电话</div>
                            <div class="ZhuanYeItemVal"><el-input size="small" placeholder="请输入" v-model="consultant1.mobile"></el-input></div>
                        </div>
                        <div class="ZhuanYeItemDis">
                            <div class="ZhuanYeItemFuTit"></div>
                            <div class="ZhuanYeItemVal button-group">
                                <el-button type="primary" size="small" @click="downloadTemplate">下载模板</el-button>
                                <el-upload action="none" size="small" :show-file-list="false" :http-request="(file) => UpFile(file, 'consultant1')">
                                    <el-button type="primary" size="small">上传</el-button>
                                </el-upload>
                                <div class="StepCommFileImg" v-if="consultant1.file">
                                    <img :src="$Global._isFileName(consultant1.file)" alt="" @click="OpenLock(consultant1.file)">
                                    <i class="iconfont icon-guanbi2fill" @click="CloseImg(consultant1)"></i>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="ZhuanYeItem" v-if="user_group_id != 3 && user_group_id != '3' && user_group_id != 4 && user_group_id != '4'">
                <div class="ZhuanYeItemCont" v-if="selected === 3">
                    <div class="ZhuanYeItemTit">注册心理咨询师2</div>
                    <div>
                        <div class="ZhuanYeItemDis">
                            <div class="ZhuanYeItemFuTit">姓名</div>
                            <div class="ZhuanYeItemVal"><el-input size="small" placeholder="请输入"
                                    v-model="consultant2.name"
                                    @input="onInputName(consultant2.name, selected, 'consultant2')"></el-input></div>
                        </div>
                        <div class="ZhuanYeItemDis">
                            <div class="ZhuanYeItemFuTit">注册号</div>
                            <div class="ZhuanYeItemVal"><el-input size="small" placeholder="请输入"
                                    v-model="consultant2.code"></el-input></div>
                        </div>
                        <div class="ZhuanYeItemDis">
                            <div class="ZhuanYeItemFuTit">电话</div>
                            <div class="ZhuanYeItemVal"><el-input size="small" placeholder="请输入" v-model="consultant2.mobile"></el-input></div>
                        </div>
                        <div class="ZhuanYeItemDis">
                            <div class="ZhuanYeItemFuTit"></div>
                            <div class="ZhuanYeItemVal button-group">
                                <el-button type="primary" size="small" @click="downloadTemplate">下载模板</el-button>
                                <el-upload action="none" size="small" :show-file-list="false" :http-request="(file) => UpFile(file, 'consultant2')">
                                    <el-button type="primary" size="small">上传</el-button>
                                </el-upload>
                                <div class="StepCommFileImg" v-if="consultant2.file">
                                    <img :src="$Global._isFileName(consultant2.file)" alt="" @click="OpenLock(consultant2.file)">
                                    <i class="iconfont icon-guanbi2fill" @click="CloseImg(consultant2)"></i>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="StepComm">
            <div class="StepCommItem" v-for="(item, index) in FormData" :key="item.id" v-if="FormData">
                <div class="StepCommNum">{{ index + 1 }}.</div>
                <div class="StepCommHead">
                    <div class="StepCommFile" :class="{ MarTop: index > 0 }" v-if="item.question.type == 1">
                        <div class="StepCommFileTit">{{ item.question.name }}</div>
                        <div class="StepCommFileTxt">
                            <el-upload action="none" size="small" :show-file-list="false" :http-request="UpFile"
                                :data="item.question">
                                <div class="StepCommFileBtn">上传</div>
                            </el-upload>
                            <div class="StepCommFileMsg">（上传word、pdf、jpg等格式文件）</div>
                            <!-- <div class="StepCommFileLock" v-if="item.question.file" @click="OpenLock(item.question.file)">查看</div> -->
                            <div class="StepCommFileImg" v-if="item.question.file">
                                <img :src="$Global._isFileName(item.question.file)" alt=""
                                    @click="OpenLock(item.question.file)">
                            </div>
                        </div>
                    </div>
                    <div class="StepCommIpt" :class="{ MarTop: index > 0 }" v-if="item.question.type == 2">
                        <div class="StepCommIptTxt">{{ item.question.name }}</div>
                        <div class="StepCommIptVal"><el-input size="small" placeholder="请输入"
                                v-model="item.question.val"></el-input></div>
                        <div class="StepCommIptTime">{{ item.question.unit }}</div>
                    </div>
                    <div class="StepCommIpt" :class="{ MarTop: index > 0 }" v-if="item.question.type == 3">
                        <div class="StepCommIptTxt">{{ item.question.name }}</div>
                    </div>
                    <div v-for="items in item.question.children" :key="items.id">
                        <div class="StepCommFile MarTop" v-if="items.type == 1">
                            <div class="StepCommFileTit">{{ items.name }}</div>
                            <div class="StepCommFileTxt">
                                <el-upload size="small" action="none" :show-file-list="false" :http-request="UpFile"
                                    :data="items">
                                    <div class="StepCommFileBtn">上传</div>
                                </el-upload>
                                <div class="StepCommFileMsg">（上传word、pdf、jpg等格式文件）</div>
                                <!-- <div class="StepCommFileLock" v-if="items.file" @click="OpenLock(items.file)">查看</div> -->
                                <div class="StepCommFileImg" v-if="items.file">
                                    <img :src="$Global._isFileName(items.file)" alt="" @click="OpenLock(items.file)">
                                </div>
                            </div>
                        </div>
                        <div class="StepCommIpt MarTop" v-if="items.type == 2">
                            <div class="StepCommIptTxt">{{ items.name }}</div>
                            <div class="StepCommIptVal"><el-input size="small" placeholder="请输入"
                                    v-model="items.val"></el-input></div>
                            <div class="StepCommIptTime">{{ items.unit }}</div>
                        </div>
                        <div class="StepCommIpt MarTop" v-if="items.type == 3">
                            <div class="StepCommIptTxt">{{ items.name }}</div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="StepBtns">
                <div class="StepBtn" @click="ToggleStep('prve')" :class="{ StpepDisabled: ConfigDisabled }">上一步</div>
                <div class="StepBtn" @click="ToggleStep('next')" :class="{ StpepDisabled: ConfigDisabled }">提交</div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            ID: "",
            EdiId: "",
            mechanism: {
                name: "",
                code: "",
                file: "",
            },
            tutor: {
                name: "",
                mobile: "",
                code: "",
                file: "",
                user_id: "",
            },
            tutor2: {
                name: "",
                mobile: "",
                code: "",
                file: "",
                user_id: "",
            },
            consultant1: {
                name: "",
                mobile: "",
                code: "",
                file: "",
                user_id: "",
            },
            consultant2: {
                name: "",
                mobile: "",
                code: "",
                file: "",
                user_id: "",
            },
            FormData: "",
            ConfigDisabled: false,
            selected: 1,
            timeout: null,
        }
    },
    props: {
        id: "",
        TypeId: "",
        PageDisabled: false,
        user_group_id: {
            type: [String, Number],
            default: ""
        }
    },
    mounted() {
        this.ID = this.id;
        this.ConfigDisabled = this.PageDisabled;
        if (this.$route.query.type) {
            this.ConfigDisabled = false;
            var InfoData = JSON.parse(localStorage.getItem("InfoData"));
            this.ID = { id: InfoData.id };
            
            // 处理多个information的情况（兼容 consultant/tutor 可能为对象或数组，且可能分散在多条记录中）
            if (InfoData.information && InfoData.information.length > 0) {
                const infos = InfoData.information;
                this.EdiId = infos[0].id;

                // 临时容器，按顺序填充
                let tempMechanism = null;
                let tempTutorList = [];
                let tempConsultantList = [];

                infos.forEach(item => {
                    // mechanism 取第一个非空
                    if (!tempMechanism && item.mechanism && item.mechanism !== "") {
                        try { tempMechanism = JSON.parse(item.mechanism); } catch (e) {}
                    }

                    // 解析 tutor，可能为字符串化的对象/数组
                    if (item.tutor && item.tutor !== "") {
                        try {
                            const parsedTutor = JSON.parse(item.tutor);
                            if (Array.isArray(parsedTutor)) {
                                tempTutorList = tempTutorList.concat(parsedTutor.filter(Boolean));
                            } else if (parsedTutor && typeof parsedTutor === 'object') {
                                tempTutorList.push(parsedTutor);
                            }
                        } catch (e) {}
                    }

                    // 解析 consultant，可能为字符串化的对象/数组
                    if (item.consultant && item.consultant !== "") {
                        try {
                            const parsedConsultant = JSON.parse(item.consultant);
                            if (Array.isArray(parsedConsultant)) {
                                tempConsultantList = tempConsultantList.concat(parsedConsultant.filter(Boolean));
                            } else if (parsedConsultant && typeof parsedConsultant === 'object') {
                                tempConsultantList.push(parsedConsultant);
                            }
                        } catch (e) {}
                    }
                });

                // 赋值 mechanism
                if (tempMechanism) {
                    this.mechanism = tempMechanism;
                }

                // 赋值 tutor（督导师），最多取前两个
                if (tempTutorList.length > 0) {
                    this.tutor = Object.assign({ name: "", mobile: "", code: "", file: "", user_id: "" }, tempTutorList[0] || {});
                    if (tempTutorList.length > 1) {
                        this.tutor2 = Object.assign({ name: "", mobile: "", code: "", file: "", user_id: "" }, tempTutorList[1] || {});
                    }
                }

                // 赋值 consultant（咨询师），最多取前两个
                if (tempConsultantList.length > 0) {
                    this.consultant1 = Object.assign({ name: "", mobile: "", code: "", file: "", user_id: "" }, tempConsultantList[0] || {});
                    if (tempConsultantList.length > 1) {
                        this.consultant2 = Object.assign({ name: "", mobile: "", code: "", file: "", user_id: "" }, tempConsultantList[1] || {});
                    }
                }
            } else {
                // 保持原有的单条数据处理逻辑，增加健壮性
                this.EdiId = InfoData.information && InfoData.information[0].id;
                this.mechanism = InfoData.information && InfoData.information[0].mechanism ? JSON.parse(InfoData.information && InfoData.information[0].mechanism) : { name: "", code: "" };
                this.tutor = InfoData.information && InfoData.information[0].tutor ? JSON.parse(InfoData.information && InfoData.information[0].tutor) : { name: "", mobile: "", code: "", file: "", user_id: "" };
                this.tutor2 = InfoData.information && InfoData.information[0].tutor2 ? JSON.parse(InfoData.information && InfoData.information[0].tutor2) : { name: "", mobile: "", code: "", file: "", user_id: "" };
                var Arr = InfoData.information && InfoData.information[0].consultant ? JSON.parse(InfoData.information && InfoData.information[0].consultant) : "";
                if (Arr) {
                    if (Array.isArray(Arr)) {
                        if (Arr[0]) this.consultant1 = Arr[0];
                        if (Arr[1]) this.consultant2 = Arr[1];
                    } else if (typeof Arr === 'object') {
                        this.consultant1 = Object.assign(this.consultant1, Arr);
                    }
                }
            }
        }
    },
    methods: {
        UpFile({ file }, type) {
            var fd = new FormData()
            fd.append('file', file);
            this.$Global.FileUpData(fd, (res) => {
                console.log('Upload response:', res);
                if (res.code === 1) {
                    const fileUrl = res.data.fullurl || res.data.url;
                    if (type === 'mechanism') {
                        this.mechanism.file = fileUrl;
                    } else if (type === 'tutor') {
                        this.tutor.file = fileUrl;
                    } else if (type === 'tutor2') {
                        this.tutor2.file = fileUrl;
                    } else if (type === 'consultant1') {
                        this.consultant1.file = fileUrl;
                    } else if (type === 'consultant2') {
                        this.consultant2.file = fileUrl;
                    }
                    this.$forceUpdate();
                    this.$message.success('文件上传成功');
                } else {
                    this.$message.error(res.msg || '文件上传失败');
                }
            })
        },
        CloseImg(obj) {
            // 直接清空传递对象的file属性
            if (obj && typeof obj === 'object') {
                obj.file = '';
            }
        },
        GetFormData(val) {
            this.$get("api/join_in/getRegisterInformation", {
                page: 4,
                user_group_id: val,
            }).then(res => {
                if (res.data.code == 1) {
                    this.FormData = res.data.data;
                } else {
                    this.$message.error(res.data.msg)
                }
            })
        },
        ToggleStep(s) {
            if (this.ConfigDisabled) { return; }
            if (s == "next") {
                // 文件上传验证
                if (this.selected === 1) {
                    // 选择了"所在心理服务专业机构"
                    if (!this.mechanism.name || !this.mechanism.code) {
                        this.$message.error("请填写完整的机构信息");
                        return;
                    }
                    if (!this.mechanism.file) {
                        this.$message.error("请上传机构相关文件");
                        return;
                    }
                } else if (this.selected === 2) {
                    // 选择了"注册督导师"
                    if (!this.tutor.name || !this.tutor.code || !this.tutor.mobile) {
                        this.$message.error("请填写完整的注册督导师1信息");
                        return;
                    }
                    if (!this.tutor.file) {
                        this.$message.error("请上传注册督导师1相关文件");
                        return;
                    }
                    
                    // 如果是用户组3或4，需要第二个督导师
                    if (this.user_group_id == 3 || this.user_group_id == 4) {
                        if (!this.tutor2.name || !this.tutor2.code || !this.tutor2.mobile) {
                            this.$message.error("请填写完整的注册督导师2信息");
                            return;
                        }
                        if (!this.tutor2.file) {
                            this.$message.error("请上传注册督导师2相关文件");
                            return;
                        }
                    }
                } else if (this.selected === 3) {
                    // 选择了"注册心理咨询师"
                    if (!this.consultant1.name || !this.consultant1.code || !this.consultant1.mobile) {
                        this.$message.error("请填写完整的注册心理咨询师1信息");
                        return;
                    }
                    if (!this.consultant1.file) {
                        this.$message.error("请上传注册心理咨询师1相关文件");
                        return;
                    }
                    
                    if (!this.consultant2.name || !this.consultant2.code || !this.consultant2.mobile) {
                        this.$message.error("请填写完整的注册心理咨询师2信息");
                        return;
                    }
                    if (!this.consultant2.file) {
                        this.$message.error("请上传注册心理咨询师2相关文件");
                        return;
                    }
                }

                var num = 0;
                var Arr = [];
                var Quy = {};
                var Url = "api/join_in/referralInformation";
                Quy.id = this.EdiId;
                Quy.register_professional_id = this.ID.id;
                Quy.mechanism = "";
                Quy.tutor = "";
                Quy.consultant = "";
                if (this.mechanism.name && this.mechanism.code) {
                    // Quy.mechanism="姓名:"+this.mechanism.name+",注册码:"+this.mechanism.code
                    Quy.mechanism = JSON.stringify(this.mechanism);
                }
                if (this.tutor.name && this.tutor.code && this.tutor.mobile) {
                    // Quy.tutor="姓名:"+this.tutor.name+",注册码:"+this.tutor.code+",电话:"+this.tutor.mobile
                    if (this.user_group_id == 3 || this.user_group_id == 4) {
                        if (this.tutor2.name && this.tutor2.code && this.tutor2.mobile) {
                            Quy.tutor = JSON.stringify([this.tutor, this.tutor2]);
                        } else {
                            this.$message.error("请填写完整的注册督导师2信息");
                            return;
                        }
                    } else {
                        Quy.tutor = JSON.stringify([this.tutor]);
                    }
                }
                if (this.consultant1.name && this.consultant1.code && this.consultant1.mobile && this.consultant2.name && this.consultant2.code && this.consultant2.mobile) {
                    // Quy.consultant="姓名:"+this.consultant1.name+",注册码:"+this.consultant1.code+",电话:"+this.consultant1.mobile+",姓名:"+this.consultant2.name+",注册码:"+this.consultant2.code+",电话:"+this.consultant2.mobile
                    Quy.consultant = JSON.stringify([this.consultant1, this.consultant2]);
                }
                if (Quy.mechanism == "" && Quy.tutor == "" && Quy.consultant == "") {
                    this.$message.error("心理服务专业机构或注册督导师最少填写一项");
                    return;
                }
                this.$post(Url, Quy).then(res => {
                    if (res.data.code == 1) {
                        this.$message.success(res.data.msg);
                        
                        // 根据是否为编辑模式决定删除哪些数据
                        if (this.$route.query.type) {
                            // 编辑模式：删除InfoData和specialtyInfoData
                            localStorage.removeItem('InfoData');
                            localStorage.removeItem('specialtyInfoData');
                            localStorage.removeItem('replenishInfoData');
                            localStorage.removeItem('filteredUrl');
                        } else {
                            // 新建模式：清除所有保存的数据
                            localStorage.removeItem('basicInfoData');
                            localStorage.removeItem('specialtyInfoData');
                            localStorage.removeItem('replenishInfoData');
                            localStorage.removeItem('filteredUrl');
                            localStorage.removeItem('InfoData');
                        }
                        
                        // 跳转到用户中心或成功页面
                        this.$router.push({
                            path: '/UserInfo',
                            query: {
                                id: this.TypeId == 1 ? 2 : 3
                            }
                        });
                    } else {
                        this.$message.error(res.data.msg)
                    }
                })
            } else {
                this.$emit("PageBtn", "prve")
            }
        },
        OpenLock(file) {
            if (file) {
                this.$Global.previewFile(file);
            }
        },
        //跳转
        GoPage(url) {
            this.$router.push({
                path: url
            });
        },
        // 输入调接口
        onInputName(val, index, type) {
            this.debounce(() => {
                this.$get("api/join_in/getUserList", {
                    type: index,
                    name: val,
                }).then(res => {
                    if (res.data.code == 1) {
                        if(!res.data.data) {
                            this.$message.error('查无此人/机构')
                        } else if (type === 'mechanism') {
                            this.mechanism.code = res.data.data.code
                        } else if (type === 'tutor') {
                            this.tutor.code = res.data.data.code
                            this.tutor.user_id = res.data.data.user_id
                        } else if (type === 'tutor2') {
                            this.tutor2.code = res.data.data.code
                            this.tutor2.user_id = res.data.data.user_id
                        } else if (type === 'consultant1') {
                            this.consultant1.code = res.data.data.code
                            this.consultant1.user_id = res.data.data.user_id
                        } else if (type === 'consultant2') {
                            this.consultant2.code = res.data.data.code
                            this.consultant2.user_id = res.data.data.user_id
                        }
                        
                    } else {
                        this.$message.error(res.data.msg)
                    }
                })
            })
            
        },
        debounce(func, wait=500) {
            clearTimeout(this.timeout)
            this.timeout = setTimeout(func, wait);
        },
        GoBack() {
            this.$router.push({
                path: '/UserInfo',
                query: {
                    id: this.TypeId == 1 ? 2 : 3
                }
            })
        },
        downloadTemplate() {
            window.open('https://rps.camh.org.cn/uploads/20250613/44fcc82cc43bbb5504305e448196a770.docx');
        },
    },
    watch: {
        TypeId: function (val) {
            console.log(111)
            this.TypeId = val;
        }
    },
}
</script>

<style scoped>
.MarTop {
    margin-top: 20px;
}

.Steps {
    display: none;
    align-items: center;
    margin: 30px 0;
}

.StepsItem {
    flex: 1;
    height: 50px;
    line-height: 50px;
    text-align: center;
    background: #F5F5F5;
    position: relative;
    font-weight: 400;
    font-size: 18px;
    color: #999;
}

.StepHeadTit {
    padding: 10px 20px;
    font-weight: 400;
    font-size: 16px;
    color: #999999;
    background: #f5f5f5;
    margin-bottom: 20px;
}

.StepCommItem {
    display: flex;
    align-items: baseline;
}

.StepCommNum {
    font-weight: 400;
    font-size: 20px;
    color: #000000;
}

.StepCommHead {
    margin-left: 20px;
    flex: 1;
}

.StepCommFile {
    font-weight: 400;
    font-size: 16px;
    color: #666;
    display: flex;
    flex-wrap: wrap;
    align-items: center;
}

.StepCommFileDis {
    display: flex;
    align-items: center;
}

.StepCommFileTxt {
    display: flex;
    align-items: center;
}

.StepCommFileBtn {
    font-size: 16px;
    padding: 3px 35px;
    background: #0185eb;
    border-radius: 5px;
    border: 1px solid #0185eb;
    text-align: center;
    cursor: pointer;
    color: #fff;
}

.StepCommFileMsg {
    font-weight: 400;
    font-size: 16px;
    color: #999999;
}

.StepCommIpt {
    display: flex;
    align-items: center;
    font-weight: 400;
    font-size: 16px;
    color: #666;
}

.StepCommIptVal {
    width: 80px;
    margin: 0 10px;
}

.StepCommIptMsg {
    margin-left: 10px;
    font-weight: 400;
    font-size: 16px;
    color: #0385EB;
    display: none;
}

.StepCommFileLock {
    font-size: 16px;
    color: #0385EB;
    padding: 0 10px;
}

.StepCommFileImg {
    border: 1px solid #ddd;
    padding: 2px;
    cursor: pointer;
    position: relative;
    display: inline-block;
    margin-left: 10px;
}

.StepCommFileImg img {
    width: 50px;
    height: 50px;
    display: block;
}

.StepCommFileImg .iconfont {
    position: absolute;
    top: -8px;
    right: -8px;
    width: 16px;
    height: 16px;
    line-height: 16px;
    text-align: center;
    font-size: 12px;
    color: #fff;
    background-color: #ff4d4f;
    border-radius: 50%;
    cursor: pointer;
    z-index: 9;
    display: flex;
    align-items: center;
    justify-content: center;
}

.StepCommFileImg .iconfont::before {
    content: "×";
    font-size: 14px;
    font-weight: bold;
    transform: scale(1.2);
}

.StepCommFileImg .iconfont:hover {
    background-color: #ff7875;
}

.StepCommIpts {
    display: flex;
    align-items: baseline;
}

.StepCommIptsDis {
    display: flex;
    align-items: baseline;
}

.StepCommIptsTit {
    font-weight: 400;
    font-size: 20px;
    color: #000000;
    margin-right: 20px;
}

.StepCommIptsHref {
    width: 65%;
}

.StepCommIptsHrefDis {
    flex: 1;
    margin-right: 40px;
}

.StepCommIptsHrefMsg {
    margin-top: 10px;
    cursor: pointer;
    font-weight: 400;
    font-size: 16px;
    color: #0385EB;
}

.StepCommIptsPass {
    flex: 1;
}

.StepBtns {
    display: flex;
    align-items: center;
    justify-content: center;
    margin: 30px 0
}

.StepBtn {
    margin-right: 20px;
    width: 120px;
    text-align: center;
    padding: 7px 15px;
    color: #fff;
    font-size: 18px;
    background: #0286eb;
    border-radius: 20px;
    cursor: pointer;
}

.StepBtn.StpepDisabled {
    background: #80c1f3;
    cursor: no-drop;
}

.ZhuanYe {
    border: 1px solid #eee;
    padding-bottom: 30px;
}

.ZhuanYeItem {
    width: 60%;
    margin: 0 auto 20px;
    /* display: flex;
        justify-content: space-between;
        align-items: baseline; */
}

.ZhuanYeItemRadio {
    font-size: 16px;
    margin-bottom: 10px;
}

.ZhuanYeItemRadio .radio {
    cursor: pointer;
}

input[type="radio"] {
    accent-color: #0385EB;
}

.ZhuanYeItemRadio .radio-label {
    cursor: pointer;
    margin-left: 5px;
    font-weight: 600;
}

.ZhuanYeItemTit {
    text-align: center;
    font-weight: 400;
    font-size: 16px;
    color: #666666;
    padding: 10px 0;
}

.ZhuanYeItemDis {
    display: flex;
    align-items: center;
    margin-bottom: 20px;
}

.ZhuanYeItemCont {
    width: 75%;
    margin: 0 auto;
}

.ZhuanYeItemFuTit {
    font-weight: 400;
    font-size: 16px;
    color: #666666;
    width: 15%;
}

.ZhuanYeItemVal {
    margin-left: 20px;
    flex: 1;
}

.note-text {
    font-size: 14px;
    color: #999;
    margin-left: 5px;
}

.button-group {
    display: flex;
    gap: 10px;
    align-items: center;
}

.button-group .el-upload {
    margin-left: 0;
    display: inline-block;
}

.upload-inline {
    display: inline-block !important;
}

.upload-inline .el-upload {
    display: inline-block !important;
}

@media only screen and (max-width: 550px) {
    .Steps {
        display: flex;
    }

    .StepHeadTit {
        margin-bottom: 10px;
    }

    .ZhuanYeItem {
        display: block;
        width: 90%;
    }

    .ZhuanYeItemRadio {
        cursor: pointer;
    }

    .ZhuanYeItemFuTit {
        width: 80px;
        font-size: 16px;
    }

    .ZhuanYeItemCont {
        width: 100%;
    }

    .ZhuanYeItemDis {
        margin: 10px 0 0;
    }

    .StepCommFileDis {
        display: block;
    }

    .StepCommFileTxt {
        flex-wrap: wrap;
        font-size: 18px;
        margin-top: 10px;
    }

    .StepCommFileDis .StepCommFileTxt {
        margin-top: 10px;
    }

    .StepCommItem {
        margin-top: 20px;
    }

    .StepCommFile,
    .StepCommIpt {
        font-size: 18px;
        flex-wrap: wrap;
    }

    .StepCommIpts {
        display: block;
    }

    .StepCommIptsTit {
        font-size: 16px;
        width: 80px;
        text-align: right;
    }

    .StepCommIptsHref {
        width: 100%;
    }
}
</style>